import apiClient from 'ps-components/lib/apiClient';

export const RECENT_REPORTS_FETCH_FAIL = 'DB_RECENT_REPORTS_FETCH_FAIL';
export const RECENT_REPORTS_FETCH_INIT = 'DB_RECENT_REPORTS_FETCH_INIT';
export const RECENT_REPORTS_FETCH_SUCCESS = 'DB_RECENT_REPORTS_FETCH_SUCCESS';
export const GET_FAVORITE_REPORTS_INIT = 'DB_GET_FAVORITE_REPORTS_INIT';
export const GET_FAVORITE_REPORTS_SUCCESS = 'DB_GET_FAVORITE_REPORTS_SUCCESS';
export const GET_FAVORITE_REPORTS_FAIL = 'DB_GET_FAVORITE_REPORTS_FAIL';
export const REPORTS_SWITCH_TAB = 'DB_REPORTS_SWITCH_TAB';

export const FAVORITE_REPORTS = 0;
export const RECENT_REPORTS = 1;

const initialState = {
  data: [],
  favoriteReports: [],
  favoritesError: '',
  favoritesLoading: '',
  favoritesRetries: 0,
  error: '',
  loading: true,
  retries: 0,
  selectedTabIndex: FAVORITE_REPORTS
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECENT_REPORTS_FETCH_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
        retries: state.retries + 1
      };
    case RECENT_REPORTS_FETCH_INIT:
      return {
        ...state,
        loading: true
      };
    case RECENT_REPORTS_FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        retries: 0
      };
    case GET_FAVORITE_REPORTS_INIT:
      return {
        ...state,
        favoritesLoading: true
      };
    case GET_FAVORITE_REPORTS_SUCCESS: {
      let newIndex = state.selectedTabIndex;
      if (state.selectedTabIndex === FAVORITE_REPORTS && action.data.length === 0) {
        newIndex = RECENT_REPORTS;
      }
      return {
        ...state,
        favoritesLoading: false,
        favoriteReports: action.data,
        favoritesRetries: 0,
        selectedTabIndex: newIndex
      };
    }
    case GET_FAVORITE_REPORTS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
        favoritesRetries: state.favoriteRetries + 1
      };
    case REPORTS_SWITCH_TAB:
      return {
        ...state,
        selectedTabIndex: action.index
      };
    default:
      return state;
  }
}

export const actions = {};

actions.getRecentReports = async function getRecentReports(dispatch) {
  dispatch({ type: RECENT_REPORTS_FETCH_INIT });
  try {
    const { data } = await apiClient.apiPost('api/statistics/report/recentReports', {});

    if (data?.Reports) {
      const recentReports = data.Reports.map(report => {
        return {
          id: report.id,
          name: report.name,
          lastModified: report.lastModified,
          lastModifiedBy: {
            id: 1,
            firstName: report.lastModifiedBy
          }
        };
      });

      dispatch({
        type: RECENT_REPORTS_FETCH_SUCCESS,
        data: recentReports
      });
    }
  } catch (error) {
    dispatch({
      type: RECENT_REPORTS_FETCH_FAIL,
      error: error.message
    });
    console.error(error);
  }
};

actions.getFavoriteReports = async function getFavoriteReports(dispatch) {
  dispatch({ type: GET_FAVORITE_REPORTS_INIT });

  try {
    const response = await apiClient.apiPost('api/report-library/reports/getReportList', {
      isFavorite: true,
      include: 'ALL',
      scopeCode: 'global',
      sortDirection: 'ASC',
      sortField: 'name',
      limit: 1000,
      offset: 0
    });
    const { success, reports } = response.data;

    if (success) {
      dispatch({
        type: GET_FAVORITE_REPORTS_SUCCESS,
        data: reports.edges
      });
    }
  } catch (error) {
    dispatch({
      type: GET_FAVORITE_REPORTS_FAIL,
      error: error.message
    });
    console.error(error);
  }
};

actions.switchReportTab = async function switchReportTab(dispatch, index) {
  dispatch({ type: REPORTS_SWITCH_TAB, index });
};
